import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type OrgRoleDetailsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type OrgRoleDetailsQuery = { orgRole?: { id: string, name: string, description?: string | null, userCount?: number | null, skillCount?: number | null } | null };


export const OrgRoleDetailsDocument = /*#__PURE__*/ gql`
    query orgRoleDetails($id: String!) {
  orgRole(filters: {id: $id}) {
    id
    name
    description
    userCount
    skillCount
  }
}
    `;

export function useOrgRoleDetailsQuery(options: Omit<Urql.UseQueryArgs<OrgRoleDetailsQueryVariables>, 'query'>) {
  return Urql.useQuery<OrgRoleDetailsQuery, OrgRoleDetailsQueryVariables>({ query: OrgRoleDetailsDocument, ...options });
};